import type { IBatchStore } from '../batch-store-types';

/**
 * Check if decum scale discharge should be held
 */
export const checkDecumHoldConditions = (
  batchStore: IBatchStore,
  initialData: any,
  scale: any,
  scaleRef: any = {},
): boolean => {
  return (
    batchStore.isHoldFeed ||
    initialData.isHoldLoad ||
    batchStore.isHoldFeedDevice(scale.id) ||
    (!scale.parentScaleId && batchStore.isHoldDischarge) ||
    (scaleRef.dischargeIsStop && !scaleRef.dischargeIsResume)
  );
};
